<template>

    <v-container fluid>
      <h1>Customer Survey</h1>
      <v-row class="px-0 py-0 my-0">
        <v-col cols="3">
          <RangeFilter
              :end="dateEnd"
              :start="dateStart"
              @getDates="getDates"
              :excludePeriod="excludePeriod"
              :defaultPeriod="defaultPeriod"
              :setDates="true"
              :disabled="loaded"
          />
        </v-col>
        <v-spacer></v-spacer>


      </v-row>
      <v-card class="elevation-2 py-0 px-0 mt-4 rounded-lg">
        <v-card-title>
          <v-row class="pa-0">
            <v-col cols="12" class="d-flex justify-end pb-0 pt-0 mt-0 mt-md-4">
              <v-spacer></v-spacer>
              <vue-excel-xlsx
                  :data="dataForExcel"
                  :columns="columnsData"
                  :filename="'Mail Report'"
                  :sheetname="`${dateStart} ~ ${dateEnd}`"
              >
                <v-btn
                    height="39"
                    min-width="39px"
                    :disabled="dataFiltered.length === 0"
                    class="ml-auto mr-5 rounded-lg px-0"
                    color="white"
                >
                  <ExportExcel/>
                </v-btn>
              </vue-excel-xlsx>

            </v-col>
          </v-row>
        </v-card-title>
        <v-hover v-model="hoverOnTable">
          <v-card-text>

            <v-data-table
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 75, 100, -1]
                  }"
                :items-per-page="25"
                dense
                :headers="headers"
                :items="dataFiltered"
                :page.sync="pagination.page"
                item-key="id"
                class="elevation-0 mt-2 table-main-container"
                :loading="loaded"
                loading-text="Loading... Please wait"
                :search="search"
                fixed-header
                height="609"

            >

              <template v-slot:item.email="{ item }">
                <span>{{ item.email}}</span>
              </template>

              <template v-slot:item.order_title="{ item }">
                <v-btn x-small color="indigo white--text" @click="showOrder(item)">{{item.order_title}}</v-btn>
              </template>

            </v-data-table>

            <v-dialog
                v-model="dialogOrderInfo"
                max-width="500px"
            >
              <v-card>
                <v-card-title>
                  <span>Order Info</span>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-left">Sale Date</th>
                        <th class="text-left">Product</th>
                        <th class="text-left">Gallons</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in Orders4Show" :key="item.date">
                        <td>{{ item.sale_date }}</td>
                        <td>{{ item.product_name }}</td>
                        <td>{{ item.gallons }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                      color="primary"
                      text
                      @click="dialogOrderInfo = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-card-text>
        </v-hover>
      </v-card>

    </v-container>

</template>


<script>

import axios from "axios";
import RangeFilter from "@/components/filters/RangePicker.vue";
// import LastTimeUpdated from "@/views/LastTimeUpdated.vue";
import ExportExcel from "@/components/customizing/ExportExcel.vue";
// import CustomColumns from "@/components/customizing/CustomColumns.vue";

class EMailDataProjection{

  constructor() {
    this.email  =null;
    this.date_send_email = null;
    this.order_id = null;
    this.order_title = null;

  }


  static ParseFromRaw(dt){
    let res = new EMailDataProjection();
    res.email = dt.email;
    res.date_send_email  =dt.date_send_email;
    res.order_id = dt.id_order;
    res.order_title = dt.order.product_name;
    res.answer_overall = dt.FeedBackAnswersModel.answer_overall;
    res.answer_easy_process=dt.FeedBackAnswersModel.answer_easy_process;
    res.answer_responsive = dt.FeedBackAnswersModel.answer_responsive;
    res.answer_likely = dt.FeedBackAnswersModel.answer_likely;
    res.answer_issues = dt.FeedBackAnswersModel.answer_issues;
    res.answer_comments = dt.FeedBackAnswersModel.answer_comments;
    res.answer_allow_use_social = dt.FeedBackAnswersModel.answer_allow_use_social?dt.FeedBackAnswersModel.answer_allow_use_social:'';

    return res;
  }

}

export default {
  name: "SurewayInfo",
  components: { ExportExcel, RangeFilter},
  data() {
    return {
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              1,//new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      pagination: {
        page: 1
      },
      loaded: false,
      data_mails_raw_response: [],
      data4table_projection:[],
      defaultPeriod: 4,
      excludePeriod: [],
      columnsData: [],
      customHeader: ['email', 'date_send_email', 'id_order'],
      dialogOrderInfo: false,
      Orders4Show:[],
      headers: [
        {text: 'Customer Email', value: 'email', class: 'black--text', filterable: false, sortable: false},
        {text: 'Survey  date', value: 'date_send_email', class: 'black--text'},
        {text: 'Order', value: 'order_title', class: 'black--text'},
        {text: 'Order #', value: 'order_id', class: 'black--text'},
        {text: 'Overall', value: 'answer_overall', class: 'black--text'},
        {text: 'Easy Process', value: 'answer_easy_process', class: 'black--text'},
        {text: 'Responsive', value: 'answer_responsive', class: 'black--text'},
        {text: 'Likely', value: 'answer_likely', class: 'black--text'},
        {text: 'Issues', value: 'answer_issues', class: 'black--text'},
        {text: 'Comments', value: 'answer_comments', class: 'black--text'},
        {text: 'Allow Use In Social', value: '[answer_allow_use_social]', class: 'black--text'},
        ],
      value: [
        {text: 'Customer Email', value: 'email', class: 'black--text', filterable: false, sortable: true},
        {text: 'Survey  date', value: 'date_send_email', class: 'black--text'},
        {text: 'Order', value: 'order_title', class: 'black--text'},
        {text: 'Order #', value: 'order_id', class: 'black--text'},
        {text: 'Overall', value: 'answer_overall', class: 'black--text'},
        {text: 'Easy Process', value: 'answer_easy_process', class: 'black--text'},
        {text: 'Responsive', value: 'answer_responsive', class: 'black--text'},
        {text: 'Likely', value: 'answer_likely', class: 'black--text'},
        {text: 'Issues', value: 'answer_issues', class: 'black--text'},
        {text: 'Comments', value: 'answer_comments', class: 'black--text'},
        {text: 'Allow Use In Social', value: '[answer_allow_use_social]', class: 'black--text'},
    ],

        selectedHeaders: [],
      search: '',
      settingsName: 'surveyReport',
      hoverOnTable: false,

      // Insert your data properties here
    };
  },
  mounted(){
    this.loadSurvayDate();
  },
  methods: {
  loadSurvayDate:function (){
    this.loaded = true;
   axios.get('/reports/surwayreport/' + this.dateStart + '/' + this.dateEnd)
       .then(resp=>{
         console.log(resp);
         this.data_mails_raw_response = resp.data.data;
         this.data4table_projection = this.data_mails_raw_response.map(eml=>{
               let proj = EMailDataProjection.ParseFromRaw(eml)
               return proj;
         });
         const tmp_sdf = this.data4table_projection;
         console.log(tmp_sdf);

         this.loaded = false;
         /*
         Paylaod
         {'date_customer_response': datetime.datetime(2024, 1, 11, 23, 19, 40, 970000),
           'date_send_email': datetime.datetime(2024, 1, 11, 15, 0, 7, 820000),
           'id': 66,
           'id_eml_sendpulse': 's73r07-0kiryb-8h',
           'id_feedback': 2,
           'email': 'kenflett@gmail.com',
           'user_guid_token': '1bb0e0bd-bcd4-4e27-83f2-4e4fbda634a7',
           'error_mailing': None,
           'id_order': 7944,
           'order': {'id': 7944,
            'gallons': 1.0,
            'keyword': 'fire resistant products',
            'manual_keyword_internal_id': 0,
            'product_name': 'FR Clear (1 Gallon Jug, Clear)',
            'state_name': 'Nova Scotia',
            'invoice_id': 0,
            'full_name': 'Ken Flett',
            'campaign': 'Canada',
            'company_name': 'Oakdene Community Centre',
            'products': '[{"id": 2, "name": "FR Clear (1 Gallon Jug, Clear)", "gallons": 1.0}]',
            'company_id': 3888,
            'primary_email': 'kenflett@gmail.com',
            'has_lead': True,
            'nop_commerce_id': 7171,
            'sib_campaign_id': 0,
            'sp_campaign_id': None,
            'sale_id': 0,
            'ship_email': 'kenflett@gmail.com',
            'ship_addr': '29 Bell rd, Bear River, NS B0S1B0, Canada',
            'qb_po_id': None,
            'copper_notes': 'Web inquiry\r\nHi, can your flame off be used on stage curtains?thanksken',
            'hub_order_id': 7193,
            'bill_email': 'kenflett@gmail.com',
            'customer_id': 774415,
            'customer_type': 'New',
            'copper_company_name': 'Oakdene Community Centre',
            'sale_date': datetime.datetime(2023, 12, 28, 17, 9, 3),
            'primary_phone': 19023081981,
            'is_created_by_admin': 0,
            'copper_info': 'newsletter,navigator-api,flameoffcoatings.com,web inquiry',
            'copper_customer_type': 'New',
            'sale_price': 75.84,
            'ship_phone': 19023081981,
            'is_manual_keyword': False,
            'copper_contact': True,
            'copper_people_id': 157660356,
            'bill_phone': 19023081981,
            'source': 'Adwords'},
           'FeedBackAnswersModel': {
            'answer_responsive': 'extremely_high',
            'id': 2,
            'answer_issues': '',
            'answer_allow_use_social': None,
            'answer_easy_process': 'extremely_high',
            'answer_overall': 'extremely_high',
            'answer_likely': 'extremely_high',
            'answer_comments': 'Your employee Abby Buley was so great. Quick to reply and very helpful. Thank you.\nken',
            'created_at': datetime.datetime(2024, 1, 11, 23, 19, 40, 877000)}}
          */
       });
  },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.pagination.page = 1
      this.applyFilters()
    },

    applyFilters(){
      this.loadSurvayDate();
    },
    getCustomData({customHeader, value, selectedHeaders}) {
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders
    },

    rowClick: function (item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    showOrder: function (item){
      let respitem = this.data_mails_raw_response.filter(el=>el.id_order == item.order_id);
      if (!respitem){
        return ;
      }
      if (respitem.length==0){
        return;
      }
      this.Orders4Show= [];
      this.Orders4Show.push( respitem[0].order);
      this.dialogOrderInfo = true;
    },

    getHeaderForExcel(){
      this.columnsData = this.headers.map(e => {
        const obj = {}
        if (e.value !== "actions") {
          obj.label = e.text
          obj.field = e.value
        }
        if (e.value === "totalSpent") {
          obj.label = `${e.text},$`
          obj.field = e.value
        }
        return obj
      }).filter(value => Object.keys(value).length !== 0)

    },

  },

  computed: {
    // Insert your computed properties here
    dataFiltered(){
      let res = this.data4table_projection;
      if (!res){
        res =[];
      }
      return res;
    },

    // eslint-disable-next-line vue/return-in-computed-property

    dataForExcel() {
      this.getHeaderForExcel();
      if (!this.dataFiltered) return []
      let data = JSON.parse(JSON.stringify(this.dataFiltered))
      return data
    },

  },
  watch:{
    dataFiltered: function () {
      this.pagination.page = 1
    },

  }
}
</script>


<style scoped>
  /* Insert your styles here */
</style>
